import { render, staticRenderFns } from "./PaymentRefound.vue?vue&type=template&id=38c22a5e&scoped=true"
import script from "./PaymentRefound.vue?vue&type=script&lang=js"
export * from "./PaymentRefound.vue?vue&type=script&lang=js"
import style0 from "./PaymentRefound.vue?vue&type=style&index=0&id=38c22a5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c22a5e",
  null
  
)

export default component.exports